<div class="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 min-h-[70vh]">
  <!-- Enhanced Header -->
  <div class="relative overflow-hidden bg-white rounded-2xl ">
    <div class="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-indigo-600/5"></div>
    <div class="relative px-6 py-6">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div class="flex items-center gap-4">
          <!-- <div class="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
            <i class="pi pi-wallet text-white text-xl"></i>
          </div> -->
          <div>
            <h1 class="text-2xl font-bold text-gray-900">Wallet Dashboard</h1>
            <!-- <p class="text-sm text-gray-600 mt-1">Manage your investments and withdrawals</p> -->
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div class="text-right hidden md:block">
            <!-- <p class="text-xs text-gray-500">Last updated</p> -->
            <!-- <p class="text-sm font-medium text-gray-700">{{ summary?.updatedAt  | date:'short' }}</p> -->
          </div>
          <button pButton icon="pi pi-refresh" label="Refresh" 
                  class="p-button-outlined p-button-sm" 
                  (click)="loadAll()"></button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loadingSummary && loadingPortfolios && loadingActivity" class="flex justify-center items-center h-48">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- Error -->
  <div *ngIf="!loadingSummary && errorMsg" class="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 mb-6">
    {{ errorMsg }}
  </div>

  <!-- WALLET CARD -->
  <div *ngIf="summary" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
    <!-- Main Wallet Card -->
    <div class="relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 group hover:shadow-xl transition-all duration-300">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-600/5"></div>
      <div class="relative p-6">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-3">
            <div class="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
              <i class="pi pi-wallet text-white text-lg"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">Wallet</h3>
          </div>
          <div *ngIf="summary.isLocked" class="inline-flex items-center text-xs text-amber-700 bg-amber-50 border border-amber-200 px-3 py-1 rounded-full">
            <i class="pi pi-lock mr-1"></i>
            Locked
          </div>
        </div>
        
        <!-- Main Metric (swapped to Total Balance) -->
        <div class="space-y-1 mb-6">
          <p class="text-sm font-medium text-gray-600">Total balance</p>
          <p class="text-3xl font-bold text-blue-600">{{ fmtMoney(summary.balance) }}</p>
        </div>

        <!-- Compact Chips Row -->
        <div class="grid grid-cols-2 gap-3 mb-6">
          <div class="bg-amber-50 rounded-xl p-3 border border-amber-100">
            <p class="text-xs font-medium text-amber-700 mb-1">On hold</p>
            <p class="text-lg font-bold text-amber-600">{{ fmtMoney(summary.pendingWithdrawals) }}</p>
          </div>
          <div class="bg-emerald-50 rounded-xl p-3 border border-emerald-100">
            <p class="text-xs font-medium text-emerald-700 mb-1">Available to withdraw</p>
            <p class="text-lg font-bold text-emerald-600">{{ fmtMoney(summary.spendableBalance) }}</p>
          </div>
        </div>

        <!-- Info Note -->
        <div class="bg-gray-50 rounded-xl p-3 mb-4">
          <p class="text-xs text-gray-600 flex items-center gap-1">
            <i class="pi pi-info-circle"></i>
            ROI is prioritized during withdrawals
          </p>
        </div>

        <!-- Primary Button -->
        <div class="space-y-2">
          <button pButton type="button" label="Withdraw Funds" icon="pi pi-arrow-up-right" 
                  class="p-button-success w-full"
                  [disabled]="!canWithdraw" 
                  [pTooltip]="withdrawDisabledReason"
                  tooltipPosition="top"
                  (click)="onWithdraw()"></button>
          
          <!-- Mini Link -->
          <div class="text-center">
            <button type="button" class="text-xs text-blue-600 hover:text-blue-800 hover:underline bg-transparent border-none cursor-pointer p-0" (click)="scrollToHistory()">
              View withdrawal history →
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Portfolio Diversification Chart -->
    <div class="lg:col-span-2 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden group hover:shadow-xl transition-all duration-300">
      <div class="bg-gradient-to-r from-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-100">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
              <i class="pi pi-chart-pie text-white"></i>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-800">Portfolio Diversification</h3>
              <p class="text-sm text-gray-600">ROI distribution across portfolios</p>
            </div>
            
          </div>
        </div>
      </div>
      
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          <div class="flex items-center justify-center">
            <div class="relative">
              <p-chart type="doughnut" [data]="chartData" [options]="chartOptions" styleClass="w-64 h-64"></p-chart>
              <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div class="text-center">
                  <p class="text-2xl font-bold text-gray-800">{{ summary.balance > 0 ? (portfolios?.length || 0) : 0 }}</p>
                  <p class="text-xs text-gray-500">Portfolios</p>
                </div>
              </div>
            </div>
          </div>
          <div class="space-y-3 md:hidden lg:block" >
            <div class="bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-4">
              <p class="text-sm font-medium text-gray-700 mb-2">Investment Insights</p>
              <div class="space-y-2 text-xs text-gray-600">
                <p>• Diversified across {{ portfolios?.length || 0 }} portfolios</p>
                <p>• ROI automatically credited monthly</p>
                <p>• Real-time portfolio performance tracking</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Credit History Section -->
  <div class="mt-8 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
    <div class="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-green-50">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-emerald-100 rounded-xl flex items-center justify-center">
            <i class="pi pi-plus text-emerald-600 text-lg"></i>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-800">Credit History</h3>
            <p class="text-sm text-gray-600">{{ recentActivity.length }} transactions</p>
          </div>
        </div>
        <!-- <button pButton type="button" label="View All" class="p-button-text p-button-sm text-emerald-600"></button> -->
      </div>
    </div>

    <div class="p-6">
      <p-table 
        [value]="recentActivity" 
        [loading]="loadingActivity"
        [paginator]="recentActivity.length > 10" 
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        styleClass="p-datatable-sm p-datatable-striped"
        [responsive]="true">
        
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="createdAt" class="text-gray-600 font-medium">
              Date <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th class="text-gray-600 font-medium">Portfolio</th>
            <th pSortableColumn="transactionType" class="text-gray-600 font-medium">
              Type <p-sortIcon field="transactionType"></p-sortIcon>
            </th>
            <th pSortableColumn="amount" class="text-gray-600 font-medium text-right">
              Amount <p-sortIcon field="amount"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-transaction>
          <tr class="hover:bg-gray-50">
            <td class="text-gray-700">{{ fmtDate(transaction.createdAt) }}</td>
            <td class="text-gray-700">{{ transaction.portfolio?.name || '—' }}</td>
            <td>
              <p-tag 
                [value]="(transaction.transactionType || '').replace('_',' ')" 
                [severity]="getTransactionSeverity(transaction.transactionType)"
                styleClass="text-xs">
              </p-tag>
            </td>
            <td class="text-right">
              <span class="font-semibold text-emerald-600">{{ fmtMoney(transaction.amount) }}</span>
            </td>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8">
              <div class="flex flex-col items-center gap-3">
                <i class="pi pi-inbox text-4xl text-gray-300"></i>
                <p class="text-gray-500">No credit history found</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- Withdrawal History Section -->
  <div id="withdrawal-history-section" class="mt-8 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition focus-within:ring-2" [ngClass]="{ 'animate-pulse ring-2 ring-red-200': historyHighlight }">
    <div class="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-red-50 to-pink-50">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center">
            <i class="pi pi-arrow-up text-red-600 text-lg"></i>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-800">Withdrawal History</h3>
            <p class="text-sm text-gray-600">{{ withdrawalHistory.length }} requests</p>
          </div>
        </div>
        <!-- <button pButton type="button" label="View All" class="p-button-text p-button-sm text-red-600"></button> -->
      </div>
    </div>

    <div class="p-6">
      <p-table 
        [value]="withdrawalHistory" 
        [loading]="loadingWithdrawals"
        [paginator]="withdrawalHistory.length > 10" 
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        styleClass="p-datatable-sm p-datatable-striped"
        [responsive]="true">
        
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="createdAt" class="text-gray-600 font-medium">
              Date <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th pSortableColumn="amount" class="text-gray-600 font-medium text-right">
              Amount <p-sortIcon field="amount"></p-sortIcon>
            </th>
            <th pSortableColumn="status" class="text-gray-600 font-medium">
              Status <p-sortIcon field="status"></p-sortIcon>
            </th>
            <!-- <th class="text-gray-600 font-medium">User Notes</th> -->
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-withdrawal>
          <tr class="hover:bg-gray-50">
            <td class="text-gray-700">{{ fmtDate(withdrawal.createdAt) }}</td>
            <td class="text-right">
              <span class="font-semibold text-red-600">{{ fmtMoney(withdrawal.amount) }}</span>
            </td>
            <td>
              <p-tag 
                [value]="withdrawal.status" 
                [severity]="getStatusSeverity(withdrawal.status)"
                styleClass="text-xs">
              </p-tag>
            </td>
            <!-- <td class="text-gray-600 text-sm">{{ withdrawal.userNotes || '—' }}</td> -->
          </tr>
        </ng-template>
        
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8">
              <div class="flex flex-col items-center gap-3">
                <i class="pi pi-inbox text-4xl text-gray-300"></i>
                <p class="text-gray-500">No withdrawal history found</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- Enhanced Withdraw Dialog -->
  <p-dialog [(visible)]="withdrawDialogVisible" [modal]="true" header="Withdraw Funds" [draggable]="false" [resizable]="false"
           [style]="{ width: '90vw', maxWidth: '480px' }">
    <div class="space-y-6">
      <!-- Amount Input -->
      <div class="space-y-3">
        <div class="flex items-center justify-between">
          <label class="text-sm font-medium text-gray-700">Withdrawal Amount</label>
          <button type="button" class="text-xs text-blue-600 hover:text-blue-800 underline bg-transparent border-none cursor-pointer p-0"
                  (click)="withdrawAmount = summary?.spendableBalance || 0">
            Max: {{ fmtMoney(summary?.spendableBalance || 0) }}
          </button>
        </div>
        <div class="relative">
          <!-- <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500">{{ summary?.currency || 'AED' }}</span> -->
          <input type="tel" pInputText 
                 placeholder="" 
                 class="w-full pl-12 text-lg font-medium placeholder:text-gray-500" 
                 [(ngModel)]="withdrawAmount" 
                 [min]="1"
                 [max]="summary?.spendableBalance || 0">
        </div>
        <p class="text-xs text-gray-600">
          <i class="pi pi-info-circle mr-1"></i>
          You can withdraw up to {{ fmtMoney(summary?.spendableBalance || 0) }} right now.
        </p>
      </div>

      <!-- Summary Card -->
      <!-- <div class="bg-gray-50 rounded-xl p-4 space-y-2" *ngIf="withdrawAmount && withdrawAmount > 0">
        <h4 class="text-sm font-medium text-gray-700">Withdrawal Summary</h4>
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Amount:</span>
          <span class="font-medium">{{ fmtMoney(withdrawAmount) }}</span>
        </div>
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Fee:</span>
          <span class="font-medium">{{ fmtMoney(0) }}</span>
        </div>
        <div class="border-t border-gray-200 pt-2 flex justify-between text-sm font-semibold">
          <span>Net Amount:</span>
          <span>{{ fmtMoney(withdrawAmount) }}</span>
        </div>
      </div> -->

      <!-- Notes -->
      <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">Notes (optional)</label>
        <textarea pInputTextarea 
                  placeholder="Add any notes for your withdrawal request..." 
                  class="w-full" 
                  rows="3" 
                  [(ngModel)]="withdrawNotes"></textarea>
      </div>

      <!-- Important Notice -->
      <div class="bg-blue-50 border border-blue-200 rounded-xl p-3">
        <p class="text-xs text-blue-700 flex items-start gap-2">
          <i class="pi pi-info-circle mt-0.5 flex-shrink-0"></i>
          <span>We'll place a temporary hold on these funds while we process your request. You'll receive updates via email.</span>
        </p>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-3">
        <button pButton label="Cancel" class="p-button-text" (click)="withdrawDialogVisible=false"></button>
        <button pButton label="Submit Request" icon="pi pi-check" 
                [loading]="submittingWithdraw" 
                [disabled]="!withdrawAmount || withdrawAmount <= 0 || withdrawAmount > (summary?.spendableBalance || 0)"
                (click)="submitWithdraw()" 
                class="p-button-success"></button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Toast container -->
  <p-toast></p-toast>
</div>
